<template>
<!--
  <div>
    <div v-if="this.$vuetify.breakpoint.smAndDown" style="margin-top:100px;text-align:center;font-size:30px;padding:20px">
      Sorry, but PŪRTRAK is not supported on mobile devices
    </div>
    <router-view v-else/>
  </div>
  -->
  <router-view/>
</template>

<script>
export default {
  name: 'Main'
}
</script>